import Vue from "vue";

const resourceRepair = {
  namespaced: true,
  mutations: {
  },
  getters: {

  },
  actions: {
    getItems({ rootState }, payload) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/crm/repair.estimate`, payload)
          .then(resolve)
          .catch(reject);
      });
    },
    get({ rootState }, { repairId, search_customer_id }) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/crm/repair.estimate/${repairId}`, { search_customer_id })
          .then(resolve)
          .catch(reject);
      });
    },
    edit({ rootState }, payload) {
      const { hostName } = rootState.config;
      const { repairEstimateId, data } = payload;

      return new Promise((resolve, reject) => {
        Vue.axios
          .put(`${hostName}/v1/crm/repair.estimate/edit/${repairEstimateId}`, data)
          .then(resolve)
          .catch(reject);
      });
    },
    create({ rootState }, { data }) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .post(`${hostName}/v1/crm/repair.estimate/create`, data)
          .then(resolve)
          .catch(reject);
      });
    },
    getAutoItems({ rootState }, { customer_id }) {
      const { hostName } = rootState.config;
      const params = {
        customer_id,
        page: 1,
        size: 100
      }
      
      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/crm/auto`, { params })
          .then(resolve)
          .catch(reject);
      });
    },
    getCompareItems({ rootState }, { repairId }) {
      const { hostName } = rootState.config;
      const params = {
        search_repair_estimate_id: repairId,
        page: 1,
        size: 100
      }

      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/crm/repair.estimate.compare`, { params })
          .then(resolve)
          .catch(reject);
      });
    },
    getCompareItem({ rootState }, { repairCompareId }) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/crm/repair.estimate.compare/${repairCompareId}`)
          .then(resolve)
          .catch(reject);
      });
    },
    editCompareItem({ rootState }, { repairCompareId, data }) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .put(`${hostName}/v1/crm/repair.estimate.compare/edit/${repairCompareId}`, data)
          .then(resolve)
          .catch(reject);
      });
    },
    getResourceItems({ rootState }, payload) {
      const { hostName } = rootState.config;
      return new Promise((resolve, reject) => {
        Vue.axios
          .get(`${hostName}/v1/www/resources`, payload)
          .then(resolve)
          .catch(reject);
      });      
    },
    uploadResources({ rootState }, payload) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .post(`${hostName}/v1/admin/resources/upload`, payload)
          .then(resolve)
          .catch(reject);
      });
    },
    deleteUploadResource({ rootState }, { id }) {
      const { hostName } = rootState.config;

      return new Promise( ( resolve, reject ) => {
        Vue.axios
        .delete(`${hostName}/v1/admin/resources/${id}`)
        .then(resolve)
        .catch(reject);
      });
    }
  }
}

export default resourceRepair;